<template>

  <!-- Table Container Card -->
  <b-card
    title="GHGHGH"
    no-body
  >

    <b-table
      ref="refInvoiceListTable"
      :items="invoicesData"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >

      <template #head(invoiceStatus)>
        <feather-icon
          icon="TrendingUpIcon"
          class="mx-auto"
        />
      </template>

      <!-- Column: Id -->
      <template #cell(id)="data">
        <b-link
          :to="{ name: 'apps-invoice-preview', params: { id: data.item.id }}"
          class="font-weight-bold"
        >
          #{{ data.value }}
        </b-link>
      </template>

      <!-- Column: Invoice Status -->
      <template #cell(invoiceStatus)="data">
        <b-avatar
          :id="`invoice-row-${data.item.id}`"
          size="32"
          :variant="`light-${resolveInvoiceStatusVariantAndIcon(data.item.invoiceStatus).variant}`"
        >
          <feather-icon
            :icon="resolveInvoiceStatusVariantAndIcon(data.item.invoiceStatus).icon"
          />
        </b-avatar>
        <b-tooltip
          :target="`invoice-row-${data.item.id}`"
          placement="top"
        >
          <p class="mb-0">
            {{ data.item.invoiceStatus }}
          </p>
          <p class="mb-0">
            Balance: {{ data.item.balance }}
          </p>
          <p class="mb-0">
            Due Date: {{ data.item.dueDate }}
          </p>
        </b-tooltip>
      </template>

      <!-- Column: Invoice No -->
      <template #cell(invoiceNo)="data">
        <span class="text-nowrap">
          {{ data.value }}
        </span>
      </template>

      <!-- Column: Issued Date -->
      <template #cell(issuedDate)="data">
        <span class="text-nowrap">
          {{ data.value }}
        </span>
      </template>

      <!-- Column: SBP year -->
      <template #cell(year)="data">
        <span class="text-nowrap">
          {{ data.value }}
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <!-- <b-button
            v-if="(data.item.status==0)"
            v-b-modal.initiate-sbp-payment
            class="mr-2"
            variant="outline-warning"
          >
            <feather-icon
              icon="DollarSignIcon"
              class="mr-20"
            />
            <span class="align-middle">Pay</span>
          </b-button> -->
          <pay-sbp-invoice
            v-if="(data.item.status==0)"
            :business-invoice-data="data.item"
          />
          <b-button
            variant="outline-success"
            @click="downloadInvoice(data.item)"
          >
            <feather-icon
              icon="ArrowDownCircleIcon"
              class="mr-20"
            />
            <span class="align-middle">Download</span>
          </b-button>
        </div>
      </template>

    </b-table>
  </b-card>

</template>

<script>
import {
  BCard, BTable, BAvatar, BButton, BLink, BTooltip,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import AppUtils from '@/auth/jwt/useJwt'
import useInvoicesList from './useInvoiceList'
import PaySbpInvoice from './PaySbpInvoice.vue'

export default {
  components: {
    BCard,
    BButton,
    BTable,
    BAvatar,
    BLink,
    BTooltip,

    PaySbpInvoice,
  },
  props: {
    invoicesData: {
      type: Array,
      required: true,
    },
  },
  methods: {
    downloadInvoice(data) {
      AppUtils.downloadInvoice(data.invoice.id)
    },
  },
  setup() {
    const {
      tableColumns,
      totalInvoices,
      dataMeta,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,

      statusFilter,

      refetchData,

      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
    } = useInvoicesList()

    return {
      tableColumns,
      totalInvoices,
      dataMeta,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,

      statusFilter,

      refetchData,

      PaySbpInvoice,

      avatarText,
      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
